// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "[data-v-b087389a] .el-drawer__body{display:flex;flex-direction:column}.title-line[data-v-b087389a]{align-items:center;background:#fff;border-bottom:.01rem solid #e5e5e5;display:flex;font-size:.2rem;font-style:normal;font-weight:700;line-height:120%;padding:.28rem .28rem .2rem}.title-line .back[data-v-b087389a]{color:var(--primary-500);height:.3rem;margin-right:.1rem;width:.3rem}.pointer[data-v-b087389a]{cursor:pointer}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
